/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { fileTooLarge, isInvalidFileType } from '../../helpers/common.helpers';
import { ALERT_WARNING, FILE_TOO_LARGE, WRONG_FILE_FORMAT } from '../../../constants/constants';
import './file-upload.style.scss';

/**
 * Class representing file upload component.
 * @extends Component
 * */
@inject('commonStore', 'filesStore')
@observer
class FileUpload extends Component {

  static propTypes = {
    commonStore: PropTypes.shape({
      show: PropTypes.func,
    }),
    filesStore: PropTypes.shape({
      uploadFile: PropTypes.func
    }),
  };

  static defaultProps = {
    commonStore: {
      show: () => {},
    },
    filesStore: {
      uploadFile: () => {},
    },
  };

  /**
   * Gets the selected file.
   * @param {object} event - The file select event.
   * */
  onFileChange = (event) => {
    event.preventDefault();

    const file = event.target.files[0];
    const { commonStore: { show }, filesStore: { createMessage } } = this.props;

    if (file && isInvalidFileType(file.type)) {
      show(WRONG_FILE_FORMAT, ALERT_WARNING);
      return;
    }

    if (file && fileTooLarge(file.size)) {
      show(FILE_TOO_LARGE, ALERT_WARNING);
      return;
    }

    if (file) {
      createMessage(file);
    }
  };

  render() {
    const { accept, buttonClass } = this.props;

    return (

      <div className="col-6 text-center btn-div">
      <button type="button" className="btn btn-link">
        <input
            title=""
            className="file-input"
            type="file"
            accept={accept}
            onChange={this.onFileChange}
        />
        <FontAwesomeIcon icon={faCloudUploadAlt} size="2x"/><br /><span>Upload</span>
      </button>
      </div>
    );
  }
}

export default FileUpload;

FileUpload.propTypes = {
  accept: PropTypes.string.isRequired,
  buttonClass: PropTypes.string,
};

FileUpload.defaultProps = {
  buttonClass: '',
};



// WEBPACK FOOTER //
// ./src/common/components/file-upload/file-upload.component.js